import { useParams } from 'react-router-dom';
import { t } from 'i18next';
import { useClient } from 'jsonapi-react';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { FiSend } from 'react-icons/fi';
import { ChatFooter, ChatForm } from '@/components/custom/chat/chat';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export default function CommentForm(props) {
  const client = useClient();
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const { commentForm } = props;

  const handleSubmit = async e => {
    e.preventDefault();
    if (loading) return;
    try {
      setLoading(true);
      await client.mutate(`/live_classrooms/${params.liveClassId}/live_classroom_messages`, {
        body: commentForm.values.body
      });

      commentForm.resetForm();
    } catch (error) {
      console.log(error);
      toast.error('Erro ao criar comentário!');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ChatFooter>
      <ChatForm onSubmit={handleSubmit}>
        <Input
          className="!w-10 grow"
          type="text"
          name="body"
          id="body"
          placeholder={t('activity.placeholderWriteComment')}
          aria-label={t('activity.placeholderWriteComment')}
          value={commentForm.values.body}
          onChange={commentForm.handleChange}
        />
        <Button
          size="icon"
          type="submit"
          disabled={loading}
          className="shrink-0"
        >
          <FiSend />
        </Button>
      </ChatForm>
    </ChatFooter>
  );
}
